import Backbone from '@polleverywhere/backbone'
import ResultsContainerTpl from './templates/results_container.hamlc'
import formatNumber from '@polleverywhere/viz-utils/lib/format-number'

function hasNoInstructionsView (self) {
  return ['discourse', 'clickable_image'].includes(self.model.type())
}

function showTotal (self) {
  const showTotalResults = self.flashOptions.get('showTotalResults')
  const instructionsViewShowTotalResults = self.flashOptions.get('instructionsViewShowTotalResults')
  const displayState = self.model.get('display_state')

  if (hasNoInstructionsView(self)) {
    return showTotalResults
  } else if (displayState === 'instructions' || displayState === 'join_instructions') {
    return instructionsViewShowTotalResults
  } else {
    return showTotalResults
  }
}

export class ResultsContainer extends Backbone.View {
  get className () {
    return 'results_container'
  }

  initialize ({ settings, dimensions }) {
    this.settings = settings
    this.dimensions = dimensions
    this.flashOptions = this.model.flashOptions()
    super.initialize(...arguments)

    this.listenTo(this.flashOptions, 'change:showTotalResults', this.toggle)
    this.listenTo(this.flashOptions, 'change:chart_primary_text_color', this.customizeColor)
    this.listenTo(this.flashOptions, 'change:instructionsViewShowTotalResults', this.toggle)

    this.listenTo(this.model, 'change:results_count', this.renderCount)
    this.listenTo(this.model, 'change:display_state', this.toggle)

    this.listenTo(this.dimensions, 'change:marginRight', this.adjustPosition)
  }

  customizeColor () {
    const color = this.flashOptions.get('chart_primary_text_color')
    this.$('.total_results_count').css('color', color)
  }

  toggle () {
    const show = showTotal(this)

    if (show) {
      this.$el.css('display', '')
    } else {
      this.$el.hide()
    }
  }

  renderCount () {
    const count = this.model.get('results_count')
    this.$('.total_results_count .count').text(formatNumber(count))
  }

  render () {
    this.$el.html(ResultsContainerTpl())
    this.customizeColor()
    this.renderCount()
    this.toggle()
    this.adjustPosition()

    return this
  }

  adjustPosition () {
    this.$('.total_results_count').css({
      paddingRight: `${this.dimensions.get('marginRight')}px`
    })
  }
}
